import { Checkbox, Divider, Dropdown, Menu } from 'antd';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';
import classNames from 'classnames';
import {
  Delete as DeleteIcon,
  Download as DownloadIcon,
  Edit as EditIcon,
  HistoricVersion,
  More as MoreIcon,
} from 'patternx-svg';
import { useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import { EmptyShaderColor, Unshelve, Shelve } from 'patternx-svg';
interface Props {
  title: string;
  material: SOURCE.Material;
  onSelectChange: (select: boolean) => void;
  thumbType: string;
  checkForce: boolean;
  choiceMode?: boolean;
  onView: () => void;
  onEdit: () => void;
  // onDelete: (success: boolean) => void;
  onDelete: () => void;
  // onCategoryChange: () => void;
  onDownload: () => void;
  onVersion: () => void;
  onUpdateSatus: () => void;
}

const MaterialCard: React.FC<Props> = (props: Props) => {
  const {
    title,
    material,
    onSelectChange,
    thumbType,
    checkForce,
    choiceMode = false,
    onView,
    onEdit,
    // onCategoryChange,
    onDelete,
    onDownload,
    onVersion,
    onUpdateSatus,
  } = props;
  const [isHover, setIsHover] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isSelect, setIsSelect] = useState(() => material._selected);
  // const [cubeThumb, setCubeThumb] = useState('');
  // const [ballThumb, setBallThumb] = useState('');
  const outerRef = useRef<HTMLDivElement>(null);
  const thumbnailRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsSelect(material._selected);
  }, [material]);

  const menu = (
    <Menu onClick={() => setIsMenuVisible(false)}>
      <Menu.Item onClick={onEdit}>
        <EditIcon size={20} style={{ marginBottom: -4, marginRight: 4 }} />
        <span>编辑</span>
      </Menu.Item>
      <Menu.Item onClick={onDownload}>
        <DownloadIcon size={20} style={{ marginBottom: -4, marginRight: 4 }} />
        <span>下载</span>
      </Menu.Item>
      <Menu.Item onClick={onVersion}>
        <HistoricVersion size={20} style={{ marginBottom: -4, marginRight: 4 }} />
        <span>版本管理</span>
      </Menu.Item>
      {/* <Menu.Item onClick={onCategoryChange}>
        <ModifyPropertiesIcon size={20} style={{ marginBottom: -4, marginRight: 4 }} />
        修改分类
      </Menu.Item> */}
      <Menu.Item onClick={onUpdateSatus}>
        {material?.onlineStatus !== 'osOffline' ? (
          <>
            <Unshelve size={20} style={{ marginBottom: -4, marginRight: 4 }} />
            下架
          </>
        ) : (
          <>
            <Shelve size={20} style={{ marginBottom: -4, marginRight: 4 }} />
            上架
          </>
        )}
      </Menu.Item>
      <Divider style={{ margin: '4px 0' }} />
      <Menu.Item onClick={onDelete}>
        <span style={{ color: 'var(--patternx-red-6)' }}>
          <DeleteIcon size={20} style={{ marginBottom: -4, marginRight: 4 }} />
          删除
        </span>
      </Menu.Item>
    </Menu>
  );

  const onMouseEnter = () => {
    setIsHover(true);
  };
  const onMouseLeave = () => {
    setIsHover(false);
  };

  const onSelect = (e: CheckboxChangeEvent) => {
    setIsSelect(e.target?.checked);
    onSelectChange(e.target?.checked);
  };

  const [imgStyle, setImgStyle] = useState<any>({ width: '100%', height: 'auto' });
  useEffect(() => {
    const imgUrl = material?.lowResBaseThumbnailUrl;
    if (imgUrl) {
      const imgEle = new Image();
      imgEle.src = imgUrl;
      imgEle.onload = function () {
        const imgWrap = thumbnailRef.current?.getBoundingClientRect();
        const imgWrapWidth = imgWrap?.width || 0;
        const imgWrapHeight = imgWrap?.height || 0;
        if (imgEle.width > imgEle.height) {
          const scaleWidth = (imgEle.width * imgWrapHeight) / imgEle.height;
          if (scaleWidth < imgWrapWidth) {
            setImgStyle({
              width: '100%',
              height: 'auto',
            });
          } else {
            setImgStyle({
              height: '100%',
              width: 'auto',
            });
          }
        } else {
          const scaleHeight = (imgEle.height * imgWrapWidth) / imgEle.width;
          if (scaleHeight < imgWrapHeight) {
            setImgStyle({
              height: '100%',
              width: 'auto',
            });
          } else {
            setImgStyle({
              width: '100%',
              height: 'auto',
            });
          }
        }
      };
    }
  }, [material?.lowResBaseThumbnailUrl]);

  const [isShowHoverImg, setIsShowHoverImg] = useState(false);

  const onMouseEnter1 = () => {
    setIsShowHoverImg(true);
  };
  const onMouseLeave1 = () => {
    setIsShowHoverImg(false);
  };

  return (
    <div
      ref={outerRef}
      className={classNames(styles.cardWrap, isSelect && styles.choiceModeSelect)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={() => {
        if (choiceMode) {
          setIsSelect(!isSelect);
          onSelectChange(!isSelect);
        }
      }}
    >
      {material?.lowResBaseThumbnailUrl && (
        <div
          className={styles.hoverThumbnail}
          style={{ display: isShowHoverImg ? 'block' : 'none' }}
        >
          <img src={material.lowResBaseThumbnailUrl} style={imgStyle} />
        </div>
      )}
      {material?.transferStatus === 'transfered' && material?.onlineStatus !== 'osOffline' && (
        <div className={classNames(styles.tag, styles.onLine)}>上架</div>
      )}
      {material?.transferStatus === 'transfered' && material?.onlineStatus === 'osOffline' && (
        <div className={classNames(styles.tag, styles.offLine)}>下架</div>
      )}
      {material?.transferStatus !== 'transfered' && material?.transferStatus !== 'fail' && (
        <div className={classNames(styles.tag, styles.doing)}>转换中</div>
      )}
      {material?.transferStatus === 'fail' && (
        <div className={classNames(styles.tag, styles.fail)}>转换失败</div>
      )}
      <div className={styles.header}>
        <Checkbox
          checked={isSelect}
          onChange={onSelect}
          className={classNames(styles.checkbox, (isHover || isSelect || checkForce) && styles.on)}
          style={{ marginRight: 10 }}
        />
      </div>
      <div
        className={styles.thumbnail}
        onClick={() => {
          if (!choiceMode) {
            onView();
          }
        }}
        onMouseEnter={onMouseEnter1}
        onMouseLeave={onMouseLeave1}
        ref={thumbnailRef}
      >
        {thumbType === 'cube' ? (
          material.cubeThumbnailUrl ? (
            <img
              src={material.cubeThumbnailUrl}
              style={{ display: isShowHoverImg ? 'none' : 'block' }}
            />
          ) : (
            <EmptyShaderColor size={180} />
          )
        ) : material.ballThumbnailUrl ? (
          <img
            src={material.ballThumbnailUrl}
            style={{ display: isShowHoverImg ? 'none' : 'block' }}
          />
        ) : (
          <EmptyShaderColor size={180} />
        )}
      </div>
      <div className={styles.footer}>
        <div className={styles.title}>{title}</div>
        <div
          className={classNames(
            styles.menu,
            isHover && styles.hover,
            isMenuVisible && styles.active,
          )}
        >
          {!choiceMode && (
            <Dropdown
              overlay={menu}
              trigger={['click']}
              overlayClassName={styles.moreMenu}
              onVisibleChange={(visible) => {
                setIsMenuVisible(visible);
              }}
            >
              <MoreIcon size={24} style={{ color: 'var(--patternx-grey-6)' }} />
            </Dropdown>
          )}
        </div>
      </div>
    </div>
  );
};

export default MaterialCard;
